import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import * as settings from 'Settings';

import styles from './PlaygroundCustomAd.scss';
import Propeller from './propeller.svg';
import Shadow from './shadow.svg';

class PlaygroundCustomAd extends Component {
  componentDidMount() {
    this.props.onAdLoad();
  }

  // componentWillUnmount() {
  //   console.log('Playground ad unmounted');
  // }

  render() {
    const { adCampaign, onAdClick } = this.props;
    const adClass = adCampaign ? ' has-active-ad' : '';
    return (
      <div className="PlaygroundCustomAd">
        <a
          className="PlaygroundCustomAd__unit"
          href={adCampaign.link}
          onClick={onAdClick}
          target="_blank"
        >
          <Propeller className="PlaygroundCustomAd__propeller" />
          <img
            className="PlaygroundCustomAd__creative"
            src={`${settings.ASSETS_URL}/img/sponsors/playground/unit/${adCampaign.customAd}`}
            alt=""
          />
        </a>
        <Shadow className="PlaygroundCustomAd__shadow" />
      </div>
    );
  }
}

export default PlaygroundCustomAd;
